import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import PickupSessionGroupApi from '../PickupSessionGroupApi';
import PickupSessionGroupCreateEditForm from './PickupSessionGroupCreateEditForm';

const PickupSessionGroupSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const { data } = props;

    const form = useForm(data);

    const update = PickupSessionGroupApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('Pickup Session Group Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <PickupSessionGroupCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

            </Col>

        </Row>

    ), [data, form, update]);

}

export default PickupSessionGroupSingleEdit;
